import { render, staticRenderFns } from "./ButtonBar.vue?vue&type=template&id=067c6a74&scoped=true"
import script from "./ButtonBar.vue?vue&type=script&lang=js"
export * from "./ButtonBar.vue?vue&type=script&lang=js"
import style0 from "./ButtonBar.vue?vue&type=style&index=0&id=067c6a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c6a74",
  null
  
)

export default component.exports